import React, { useMemo, useState } from "react"
import { CreateNewSubscriptionScreenContent } from "./v2/CreateNewSubscriptionScreenContent"
import { ScreenSkeleton } from "@common/screens/ScreenSkeleton"
import { CheckoutProvider } from "@stripe/react-stripe-js/checkout"
import { loadStripe } from "@stripe/stripe-js"
import { STRIPE_PUBLISHABLE_KEY } from "@data/constants/apiConstants"
import { connect } from "react-redux"
import { apiRequest } from "@data/redux/actions/api"
import { subscriptionService } from "@data/services/subscriptionService"
import { useRequestOnMount } from "@common/hooks/useRequestOnMount"
import base64 from "@common/utils/base64"

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)

const StagePaymentScreen = (props) => {
    const [checkoutSession, setCheckoutSession] = useState(null)
    const [stageData, setStageData] = useState(null)

    const emailB64 = props.route?.params?.user ?? ""
    const email = base64.decode((emailB64 || "").replace(/-/g, ""))

    const { initialLoadingHack } = useRequestOnMount(
        props.apiRequest,
        subscriptionService.getStageCheckoutSession,
        { body: { email } },
        (data) => {
            setStageData(data)
            setCheckoutSession({
                client_secret: data?.client_secret,
                amount: data?.amount,
                is_stage: true,
            })
        }
    )

    const subscriptionMetadata = useMemo(() => {
        if (!stageData?.holiday_courses?.length) return null
        return {
            holiday_courses: stageData.holiday_courses.map((c) => ({
                id: c.id,
                school_subject_ids: c.school_subject_ids ?? [],
            })),
        }
    }, [stageData])

    const loadingMessage = useMemo(() => {
        if (initialLoadingHack) return "Chargement de vos informations..."
        if (!checkoutSession?.client_secret) return "Préparation du paiement..."
        return null
    }, [initialLoadingHack, checkoutSession?.client_secret])

    return (
        <ScreenSkeleton
            errorScreenProps={{ error: props.error }}
            loadingMessage={loadingMessage}
            isLoading={initialLoadingHack || !checkoutSession?.client_secret}
        >
            {checkoutSession?.client_secret && (
                <CheckoutProvider
                    key={checkoutSession.client_secret}
                    stripe={stripePromise}
                    options={{
                        fetchClientSecret: async () =>
                            checkoutSession.client_secret,
                    }}
                >
                    <CreateNewSubscriptionScreenContent
                        isStage
                        checkoutSession={checkoutSession}
                        schoolSubjects={props.schoolSubjects}
                        holidayCourses={stageData?.holiday_courses ?? []}
                        subscriptionMetadata={subscriptionMetadata}
                        hideAddressCard={stageData?.has_billing_info}
                    />
                </CheckoutProvider>
            )}
        </ScreenSkeleton>
    )
}

const mapStateToProps = (state) => {
    return {
        error: state.api.getStageCheckoutSession?.error,
        schoolSubjects: state.data.staticData?.school_subjects ?? [],
    }
}

const mapDispatchToProps = {
    apiRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(StagePaymentScreen)
